import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'appointmentDistance'
})
export class AppointmentDistancePipe implements PipeTransform {
  translocoService = inject(TranslocoService);
  transform(value: number | undefined | null): string {
    if (value === undefined || value === null) {
      return this.translocoService.translate('location.appointment_distance.null');
    }

    return this.appointmentDistance(value);
  }

  appointmentDistance(id: number | undefined | null): string {
    switch (id) {
      case 0:
        return this.translocoService.translate('location.appointment_distance.0');
      case 1:
        return this.translocoService.translate('location.appointment_distance.1');
      case 2:
        return this.translocoService.translate('location.appointment_distance.2');
      case 3:
        return this.translocoService.translate('location.appointment_distance.3');
      case 4:
        return this.translocoService.translate('location.appointment_distance.4');
      case 5:
        return this.translocoService.translate('location.appointment_distance.5');
      case 6:
        return this.translocoService.translate('location.appointment_distance.6');
      case 7:
        return this.translocoService.translate('location.appointment_distance.7');
      case 8:
        return this.translocoService.translate('location.appointment_distance.8');
      default:
        return this.translocoService.translate('label.unknown');
    }
  }
}
